import { useFormContext, useController } from 'react-hook-form';
import { TextField, IconButton, InputAdornment } from '@mui/material';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import Iconify from '../../../../../reusable-components/iconify';
import { formStyle } from '../../TransitionStyles';

NumberOnlyInput.propTypes = {
  fieldName: PropTypes.string,
  focusedField: PropTypes.string,
  setFocusedField: PropTypes.func,
  fieldAttributes: PropTypes.object,
  allowDecimal: PropTypes.bool,
};

export default function NumberOnlyInput({
  fieldName,
  focusedField,
  setFocusedField,
  fieldAttributes,
  allowDecimal = false,
}) {
  const { control } = useFormContext();
  const { field, fieldState } = useController({ name: fieldName, control });
  const isCanceled = useSelector((state) => state.transitions?.data?.isCanceled);

  const sanitizeNumberValue = (value) => {
    if (!allowDecimal) return value.replace(/\D/g, '');

    const sanitized = value.replace(/[^\d.]/g, '');
    const [whole = '', ...decimalParts] = sanitized.split('.');

    if (decimalParts.length === 0) return whole;

    const decimal = decimalParts.join('').slice(0, 2);
    return `${whole}.${decimal}`;
  };

  return (
    <TextField
      inputRef={field.ref}
      key={field.id}
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
        }
      }}
      onFocus={() => setFocusedField(fieldName)}
      inputProps={{
        onBlur: () => setFocusedField(null),
      }}
      autoComplete="off"
      fullWidth
      size="small"
      type="text"
      disabled={!fieldAttributes.isEditable || isCanceled}
      value={field.value ?? ''}
      error={!!fieldState.error}
      onChange={(e) => {
        field.onChange(sanitizeNumberValue(e.target.value));
      }}
      helperText={fieldState.error?.message}
      sx={formStyle}
      InputProps={{
        sx: { background: 'white' },
        endAdornment:
          field.value && focusedField === fieldName ? (
            <InputAdornment position="end">
              <IconButton
                size="small"
                onMouseDown={(e) => {
                  e.preventDefault();
                  field.onChange('');
                }}
                edge="end"
                tabIndex={-1}
              >
                <Iconify icon="eva:close-outline" />
              </IconButton>
            </InputAdornment>
          ) : null,
      }}
    />
  );
}
